var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketingPromotion1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6603 0C9.50152 0 8.43764 0.418597 7.66875 1.23459C6.90709 2.04291 6.53955 3.12851 6.53955 4.28571V35.7143C6.53955 36.8714 6.90709 37.9571 7.66875 38.7654C8.43764 39.5814 9.50152 40 10.6603 40H29.3406C30.4992 40 31.5632 39.5814 32.3321 38.7654C33.0938 37.9571 33.4612 36.8714 33.4612 35.7143V4.28571C33.4612 3.12851 33.0938 2.04291 32.3321 1.23459C31.5632 0.418597 30.4992 0 29.3406 0H10.6603Z",
    fill: "#B3D5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 11.4286C21.5782 11.4286 22.8574 10.1495 22.8574 8.5715C22.8574 6.99354 21.5782 5.71436 20.0002 5.71436C18.4223 5.71436 17.1431 6.99354 17.1431 8.5715C17.1431 10.1495 18.4223 11.4286 20.0002 11.4286Z",
    fill: "#5D89EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingPromotion1);
export default __webpack_public_path__ + "static/media/marketing-promotion-1.50ca51c9.svg";
export { ForwardRef as ReactComponent };